import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/RootProvider.client.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/font/google/target.css?{\"path\":\"app/layout.server.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/opt/build/repo/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/react-toastify/dist/ReactToastify.css");
